<!--发表评论-->
<template>
  <div class="page" v-cloak>
    <van-nav-bar left-arrow fixed title="发表评论" id="nav-bar" @click-left="onClickLeft"></van-nav-bar>
    <!-- 文字 -->
    <van-field v-model="detail" rows="5" autosize type="textarea" placeholder="写下来只属于你的评价，帮助更多的伙伴…" />
    <div class="field-tips">
      <p class="empty" v-if="detail.length > 2" @click="empty">
        <van-icon name="clear" color="#78849E" />清空
      </p>
      <p class="limit">您已写<span>{{detail.length}}</span>字</p>
    </div>
    <!-- 图片上传 -->
    <div class="uploader-block">
      <van-uploader :after-read="afterRead" v-model="fileList" :max-size="1000 * 1024" @oversize="onOversize" multiple capture />
    </div>
    <!-- 商品详情和评分 -->
    <div class="googd-block">
      <div class="img-text-row">
        <div class="row-goods-img">
          <img src="http://qiniu.zdyxjx.com/product/upload_pic_1599124191028" alt="" />
        </div>
        <div class="row-goods-info">
          <p class="row-goods-name">ERL-蓝牙耳机ERL-蓝牙耳机ERL-蓝牙耳机ERL-蓝牙耳机ERL-蓝牙耳机ERL-蓝牙耳机ERL-蓝牙耳机ERL-蓝牙耳机</p>
          <p class="row-goods-des">中国-ERL -防水便携炫黑无线蓝牙耳机中国-ERL防水便携炫黑无线蓝牙耳机中国-ERL -防水便携炫黑无线蓝牙耳机</p>
          <p class="row-goods-sku">颜色：黑色；规格：大号</p>
        </div>
      </div>
      <p class="goods-rate">
        <span class="title">商品评价</span>
        <van-rate size="16" v-model="rate" color="#ffd21e" void-icon="star" allow-half void-color="#eee" />
        <span class="tips" v-if="rate == 5">非常好(好评)</span>
        <span class="tips" v-else-if="rate > 3">好(好评)</span>
        <span class="tips" v-else-if="rate <= 3">差(差评)</span>
      </p>
    </div>

    <p class="foot-tips">五星评价是我们的动力哟，商品如果有问题请联系我们～</p>

    <div class="foot-btn">
      <div class="btn btnl click" @click="onClickLeft">取消评价</div>
      <div class="btn btnr click" @click="Submit">确定发布</div>
    </div>

  </div>
</template>

<script type="text/babel">
export default {
  name: 'CommentIn',
  components: {},
  props: {},
  data() {
    return {
      rate: 5,
      detail: '',
      fileList: [{ url: 'https://img.yzcdn.cn/vant/leaf.jpg' }, { url: 'https://img.yzcdn.cn/vant/leaf.jpg' },],
      aa: {}
    }
  },
  watch: {
    rate: {
      handler(newValue, oldValue) {
        console.log(newValue, oldValue)
      },
      deep: true // 深度监听表单
    },
  },
  created() { },
  mounted() { },
  methods: {
    Submit() {

    },
    // 清空
    empty() {
      this.detail = ''
    },
    afterRead(file) {
      // 此时可以自行将文件上传至服务器
      console.log(file);
    },
    onOversize(file) {
      console.log(file);
      this.$toast('文件大小不能超过1M');
    },
    // 返回上一页
    onClickLeft() {
      this.$router.go(-1)
    },
  }
}
</script>

<style lang="scss" scoped>
.page {
  // height: 100%;
  width: 100%;
  padding: 46px 0 80px;
  background-color: #f9f9f9;
  .field-tips {
    background-color: #fff;
    padding: 0 10px;
    // display: flex;
    // justify-content: space-between;
    // align-items: center;
    .empty {
      float: left;
      display: flex;
      align-items: center;
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 21px;
      color: #cccccc;
    }
    .limit {
      text-align: right;
      font-size: 10px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      line-height: 17px;
      color: #cccccc;
      span {
        color: #00a8c0;
      }
    }
  }

  .uploader-block {
    text-align: left;
    padding: 10px;
    background-color: #fff;
  }
  // 横向
  .googd-block {
    padding: 10px;
    margin: 20px 10px;
    // background-color: #eee;
    background: #ffffff;
    box-shadow: 0px 2px 5px rgba(69, 79, 99, 0.06);
    border-radius: 5px;

    .img-text-row {
      width: 100%;
      height: 100px;
      background-color: #fff;
      //  background-color: palegoldenrod;
      margin-bottom: 5px;

      display: flex;
      justify-content: space-between;
      align-items: center;
      .row-goods-img {
        width: 100px;
        height: 100px;
        img {
          width: 100%;
          height: 100%;
        }
      }

      .row-goods-info {
        width: 220px;
        height: 100%;
        padding: 5px 0;
        text-align: left;
        //  background-color: paleturquoise;
        .row-goods-name {
          font-size: 13px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          line-height: 30px;
          color: #999999;
          letter-spacing: 1px;
          display: -webkit-box; /*作为弹性伸缩盒子模型显示*/
          -webkit-line-clamp: 1; /*显示的行数；如果要设置2行加...则设置为2*/
          overflow: hidden; /*超出的文本隐藏*/
          text-overflow: ellipsis; /* 溢出用省略号*/
          -webkit-box-orient: vertical; /*伸缩盒子的子元素排列：从上到下*/
        }
        .row-goods-des {
          font-size: 12px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          line-height: 20px;
          color: #cccccc;
          letter-spacing: 1px;
          display: -webkit-box; /*作为弹性伸缩盒子模型显示*/
          -webkit-line-clamp: 1; /*显示的行数；如果要设置2行加...则设置为2*/
          overflow: hidden; /*超出的文本隐藏*/
          text-overflow: ellipsis; /* 溢出用省略号*/
          -webkit-box-orient: vertical; /*伸缩盒子的子元素排列：从上到下*/
        }
        .row-goods-sku {
          display: inline-block;
          padding: 2px 10px;
          font-size: 12px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          line-height: 20px;
          color: #bbbbbb;
          letter-spacing: 1px;
          background: #f9f9f9;
          opacity: 1;
          border-radius: 5px;
        }
      }
    }
    .goods-rate {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .title {
        font-size: 18px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        line-height: 30px;
        color: #2a2e43;
        letter-spacing: 2px;
      }
      .tips {
        font-size: 15px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        line-height: 26px;
        color: #999999;
        letter-spacing: 2px;
      }
    }
  }
  .foot-tips {
    font-size: 10px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    line-height: 17px;
    color: #cccccc;
    letter-spacing: 1px;
  }

  .foot-btn {
    position: fixed;
    bottom: 10px;
    left: 0;
    width: 100%;
    height: 45px;
    background-color: #ffffff;
    border-top: 1px solid #f9f9f9;
    display: flex;
    align-items: center;
    justify-content: center;
    .btn {
      width: 172px;
      height: 40px;
      /* background: #03A8C0; */
      opacity: 1;
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      line-height: 20px;
      color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .btnl {
      background: #3acce1;
      border-radius: 20px 0px 0px 20px;
    }
    .btnr {
      background: #00a8c0;
      border-radius: 0px 20px 20px 0px;
    }
  }
}
.click:active {
 opacity: 0.8 !important;
}
</style>
